import apiClient from './apiClient';

export const authService = {
  async login(username, password) {
    try {
      const response = await apiClient.post('/auth/login', {
        username,
        password,
      });
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Login failed');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Login failed. Please try again.');
    }
  },

  async register(username, password, email) {
    try {
      const response = await apiClient.post('/auth/register', {
        username,
        password,
        email,
      });
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Registration failed');
      }
    } catch (error) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Registration failed. Please try again.');
    }
  },

  async getRegistrationStatus() {
    try {
      const response = await apiClient.get('/auth/registration-status');
      
      if (response.data.result === 'SUCCESS') {
        return response.data.data;
      } else {
        return true; // Default to enabled if we can't get the status
      }
    } catch (error) {
      console.error('Error getting registration status:', error);
      return true; // Default to enabled if we can't get the status
    }
  },
}; 